import { SingePathIcon } from './SinglePathIcon';

export const Pin = () => (
    <SingePathIcon path="M5.18676 0C7.99371 0 10.3125 2.38494 10.3125 5.33473C10.3125 11.188 0 11.188 0 5.33473C0 2.38494 2.31879 0 5.18676 0ZM5.18676 2.69874C6.40717 2.69874 7.44453 3.76569 7.44453 5.02092C7.44453 6.33891 6.40717 7.40586 5.18676 7.40586C3.90533 7.40586 2.86797 6.33891 2.86797 5.02092C2.86797 3.76569 3.90533 2.69874 5.18676 2.69874Z" />
);

Pin.viewBox = `0 0 11 10`;
